<template>
  <form
    id="search-page-form"
    class="search-page-form"
    :action="action"
    v-click-outside="close"
    @click.stop="emit('opened', true)"
  >
    <input
      class="search-page-form__input"
      type="text"
      name="q"
      maxlength="150"
      autocomplete="off"
      v-model="value"
      @input="onInput"
    >
    <button class="search-page-form__button">Поиск</button>
    <div v-if="value && resultList.length && opened" class="search-page-form__result">
      <div
        v-for="item in resultList"
        @click="selectItem(item.title, item.url)"
        class="search-page-form__result-item"
      >{{ item.title }}</div>
    </div>
  </form>
</template>
<script setup>
import { ref } from 'vue';

const props = defineProps({
  action: {
    type: String,
    default: '/search',
  },
  modelValue: {
    type: String,
    default: '',
  },
});

const value = ref(props.modelValue);

const opened = ref(false);

const resultList = ref([]);

const emit = defineEmits(['opened'])


const onInput = async () => {
  opened.value = true;
  try {
    const response = await fetch(`/api/search?q=${value.value}`);
    if (!response.ok) {
      throw new Error(`Ошибка при загрузке файла: ${response.statusText}`);
    }
    resultList.value = await response.json();
  } catch (error) {
      console.error('Ошибка:', error);
  }
}

const close = () => {
  opened.value = false;
  emit('opened', false);
}

const selectItem = (item, url) => {
  value.value = item;
  opened.value = false;
  window.location.href = url;
}

</script>
